import { camelCase, snakeCase, cloneDeep } from 'lodash';
import { createAction } from 'redux-actions';
import TransactionType from '../types/TransactionType';
import TransactionsService from '../../services/TransactionsService';
import { failedRequest, startRequest } from './GlobalActions';
import { fetchGridFiltersSuccess } from './GridFiltersActions';
import { showSuccess } from './GlobalToastActions';
import { GLOBAL } from '../../utils/Constants';
import AppUrls from '../../config/AppUrls';

const caller = new Proxy(TransactionsService, {
  apply(target, thisArg, argumentsList) {
    return target[argumentsList[0]](...argumentsList.slice(1));
  },
});

export const fetchTransactions = (filters, list, fromBackButton) => (dispatch) => {
  const service = camelCase(snakeCase(`fetch_${list}`));
  dispatch(startRequest({ action: TransactionType.actions[service], list }));
  return caller(service, filters).then(
    (transactions) => {
      const transactionsChanged = cloneDeep(transactions);
      transactionsChanged.data = transactions.data.map((transaction) => ({ ...transaction, statusDeposit: transaction.status }));
      dispatch(fetchGridFiltersSuccess(list, transactionsChanged, fromBackButton));
      return transactionsChanged;
    },
    (error) => {
      dispatch(failedRequest(error, true));
      return { error: true };
    }
  );
};

const fetchTransactionsFiltersSuccess = createAction(TransactionType.actions.fetchTransactionsFiltersSuccess);

export const fetchTransactionsFilters = (transactionType) => async (dispatch) => {
  try {
    const availableCountries = await TransactionsService.fetchCountries(transactionType);
    dispatch(fetchTransactionsFiltersSuccess({ availableCountries }));
    return { availableCountries };
  } catch (err) {
    dispatch(failedRequest(err));
    return { error: true };
  }
};

const fetchRefundDetailsSuccess = createAction(TransactionType.actions.fetchRefundDetailsSuccess);
export const fetchRefundDetails =
  (idRefund, redirect = () => {}, isRejected = false) =>
  async (dispatch) => {
    dispatch(startRequest(TransactionType.actions.fetchRefundDetailsSuccess));
    try {
      const refundDetails = await TransactionsService.fetchRefundDetails(idRefund, isRejected);
      dispatch(fetchRefundDetailsSuccess({ refundDetails }));
    } catch (error) {
      /* eslint-disable-next-line */
      redirect && redirect();
      dispatch(failedRequest(error, true));
    }
  };

const allActions = {
  fetchTransactions,
  fetchTransactionsFilters,
};
export default allActions;

export const exportAction = (filters, service, email) => async (dispatch) => {
  try {
    const request = { ...filters, ...(email && { sendTo: email }) };
    const response = await service(request);
    if (!email) {
      window.open(response);
    }
    dispatch(showSuccess('labelDownloadFile'));
  } catch (error) {
    dispatch(failedRequest(error));
  }
};

export const fetchCashInPendingVouchers = () => async (dispatch, getState) => {
  try {
    const { uploadVoucherEnabled } = getState().User.userData;
    let result = 0;
    if (uploadVoucherEnabled) {
      result = await TransactionsService.fetchCashInPendingVouchers();
    }
    return result;
  } catch (error) {
    dispatch(failedRequest(error));
    return null;
  }
};

export const downloadReceipt = (type, idTransaction, externalId) => async (dispatch) => {
  const path = type === GLOBAL.CASHIN ? AppUrls.api.cashInDownloadReceipt : AppUrls.api.cashOutDownloadReceipt;
  try {
    const data = await TransactionsService.downloadReceipt(idTransaction, path);
    const { file } = data;
    const type = file.split(';')[0].split('/')[1];
    const fileName = `receipt-${type}-id-${externalId}.${type}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = file;
    downloadLink.download = fileName;
    downloadLink.click();
  } catch (error) {
    dispatch(failedRequest(error, true));
  }
};
